import Header from '@components/Header';
import StampSheet from '@components/StampSheet';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

declare module '@stackflow/config' {
    interface Register {
        AttendanceCheckActivity: {};
    }
}

const AttendanceCheckActivity: ActivityComponentType<'AttendanceCheckActivity'> = () => {
    const a = '';
    return (
        <AppScreen>
            <Header title='출석체크' />
            <StampSheet onSuccess={() => {
                alert('출석체크 성공');
            }}/>
        </AppScreen>
    );
};

export default AttendanceCheckActivity;
